import { IconButton } from '@material-ui/core';
import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Action = lib.styled.div`
  max-height: 20px;
  margin-right: 10px;
  cursor: pointer;
  .icon {
    max-height: 20px;
    color: ${(props: any) =>
      props.active ? colors.green03 : colors.lightGray06};
  }

  &:hover {
    .icon {
      color: ${colors.green03};
    }
  }
`;

export const SectionHeader = lib.styled.div`
  height: 30px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  .line {
    height: 1px;
    background-color: ${colors.lightGray06};
    flex: 1;
  }

  span {
    padding-left: 8px;
    padding-right: 8px;
    font-weight: bold;
    font-size: 12px;
    color: ${colors.black};
    opacity: 0.5;
  }
`;

export const NameInitials = lib.styled.div`
    margin-right: 10px;
    position: relative;

    .agent-icon {
      width: 37px;
      height: 37px;
      font-size: 12px;
      margin-right: 5px;
      border: 1.8px solid ${colors.white};
      background-color: ${colors.lightGray10};
      color: #00000033;
    }

`;

export const Info = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Agent = lib.styled.div`
  border: 1px dotted ${colors.lightGray06};
  background-color: ${colors.white02};
  display: flex;
  flex-direction: row;
  max-height: 48px;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 10px;
  margin-bottom: 7px;

  .agent-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    button {
      padding: 0px !important;
      min-width: 26px !important;
      height: 26px !important;

      .call-icon {
        width: 26px !important;
        height: 26px !important;
      }
    }

    button:last-of-type {
      margin-right: 0px;
    }
  }
`;

export const Details = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: ${(props: any) => (props.selectContact ? 'column' : 'row')};
  align-items: ${(props: any) =>
    props.selectContact ? 'flex-start' : 'center'};

  .agent-name {
    font-size: 13px;
    color: ${colors.black};
    margin-left: ${(props: any) => (props.selectContact ? 0 : 5)}px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis !important;
    max-width: 145px;
    justify-content: flex-start;
    cursor: pointer;
  }

  .agent-number {
    font-size: 11px;
    color: ${colors.black};
    opacity: 0.5;
  }
`;

export const IconButtonComponent = lib.styled(IconButton)`
  .call-icon {
    ellipse {
      fill: ${(props: any) =>
        props.disabled ? colors.lightGray02 : colors.green02}!important;
    }
  }
`;
